import { AbstractControl, FormArray, ValidatorFn } from '@angular/forms';

// Custom Validator to ensure unique 'text' values in FormArray
export function uniqueTextValidator(): ValidatorFn {
    return (formArray: AbstractControl): { [key: string]: any } | null => {
        if (!(formArray instanceof FormArray)) {
            return null;
        }
        const texts = formArray
            .getRawValue()
            .map((task) => {
                return task.text?.trim();
            })
            .filter((text) => text !== null && text !== '');

        const hasDuplicates = texts.some((text, index) => texts.indexOf(text) !== index);

        return hasDuplicates ? { duplicateText: true } : null;
    };
}
